import React, { Component } from 'react'
import Select from 'react-select'

class StorePlatforms extends Component {
    constructor() {
        super()

        this.state = {
                platformList:[ {"label":"Amazon","value":"Amazon"},{"label":"DotPe","value":"DotPe"},{"label":"Foodpanda","value":"Foodpanda"},{"label":"Magicpin","value":"Magicpin"},{"label":"Swiggy","value":"Swiggy"},{"label":"Zomato","value":"Zomato"},{"label":"ZomatoMarket","value":"ZomatoMarket"}]
            }
        
        this.isComponentStillMounted = true
    }

   

    componentWillUnmount() {
        this.isComponentStillMounted = false
    }

    

    render() {
       return (
            <div>
                <Select
                value={this.props.selectedValue}
                options={this.state.platformList}
                placeholder="Select platform"
                onChange={(e) => { (e) ? this.props.storePlatformChange(e) : this.props.storePlatformChange([])}}
                />
            </div>
        )
    }
}

export default StorePlatforms


// WEBPACK FOOTER //
// ./src/common/DropDowns/StorePlatforms.js